var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6881 17.2708C10.5818 17.3951 10.4377 17.4811 10.2779 17.5159L7.98914 18.0142C7.5036 18.12 7.05135 17.7328 7.08091 17.2368L7.22025 14.8986C7.22998 14.7353 7.29281 14.5797 7.39916 14.4555L14.1002 6.62725C14.3695 6.31258 14.843 6.27584 15.1576 6.5452L17.3071 8.38512C17.6217 8.65448 17.6585 9.12794 17.3891 9.4426L10.6881 17.2708Z",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7749 11.3616L12.4535 8.51847",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e517cab277a2ce7efdc9118e6c9f833f.svg";
export { ForwardRef as ReactComponent };